var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.1667 42.5503C51.2672 48.0603 45.5808 57.8163 39.7228 57.9227C35.8368 57.9976 34.5874 55.6196 30.1455 55.6196C25.7061 55.6196 24.3165 57.8502 20.6432 57.9952C14.4275 58.2344 4.83337 43.9133 4.83337 31.4239C4.83337 19.952 12.8277 14.2656 19.8119 14.1617C23.5577 14.094 27.0957 16.6871 29.3795 16.6871C31.6729 16.6871 35.9697 13.5696 40.4865 14.0263C42.3763 14.1061 47.6857 14.7876 51.0932 19.7708C42.0525 25.6723 43.4614 38.0142 53.1667 42.5503ZM40.5469 0C33.7174 0.2755 28.1445 7.44092 28.9227 13.3666C35.235 13.8572 41.2912 6.78117 40.5469 0Z",
    fill: "#565656"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.5757c37e1a2b3d89e03deb9212a997e8.svg";
export { ForwardRef as ReactComponent };